import {html, nothing} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {property} from 'lit-element';
import type {MatchField} from '#types/journeys.js';
import type {Dataset} from '#lit/types/datasets.js';
import '../match_field_select/index.js';
import {when} from 'lit/directives/when.js';
import type {Nullable} from '#lit/types/general.js';

export const MATCH_FIELD_ROW_ELEMENT_TAG = 'match-field-row';
const DEFAULT_DATA = {label: '', value: ''};
export type SelectMatchFieldEventValue = {
  matchField: MatchField;
  selectedFieldValue: Nullable<string>;
};

/**
 * MatchFieldRow -- row component for match fields in export config modal
 */
@customElement(MATCH_FIELD_ROW_ELEMENT_TAG)
export default class MatchFieldRow extends FlywheelComponent {
  @property({type: Object})
  matchField: MatchField = DEFAULT_DATA;

  @property({type: String}) selectedValue = '';

  @property({type: Object}) selectedDataset!: Dataset;

  @property({type: String}) initial?: string;

  @property({type: Boolean}) disabled = false;

  @property({type: Boolean}) showOptional = false;

  @property({type: String}) caption = '';

  @property({type: Number})
  queueEventID?: number;

  static get styles() {
    return [styles];
  }

  dispatchSelectEvent(host: MatchFieldRow, value: SelectMatchFieldEventValue) {
    const newEvent = new CustomEvent('selected', {
      detail: {
        value,
      },
      bubbles: true,
      cancelable: false,
      composed: true,
    });
    host.dispatchEvent(newEvent);
  }
  dispatchDeselectEvent(
    host: MatchFieldRow,
    value: SelectMatchFieldEventValue
  ) {
    const newEvent = new CustomEvent('deselected', {
      detail: {
        value,
      },
      bubbles: true,
      cancelable: false,
      composed: true,
    });
    host.dispatchEvent(newEvent);
  }

  render() {
    return html`
      <div class="row__container">
        <div>
          ${this.matchField.label}
          ${when(
            !this.matchField.required && this.showOptional,
            () => html`(Optional)`,
            () => nothing
          )}
          ${when(
            this.matchField.required,
            () => html`(Required)`,
            () => nothing
          )}
          ${when(
            this.matchField.caption,
            () =>
              html`<div class="label__caption">
                ${this.matchField.caption}
              </div>`,
            () => nothing
          )}
        </div>
        <match-field-select
          ?autofocusSearch=${false}
          ?disabled=${this.disabled}
          .initial=${this.initial ?? ''}
          .compatibleTypes=${this.matchField.compatibleTypes ?? []}
          searchbar
          .selectedDataset=${this.selectedDataset}
          .queueEventID=${this.queueEventID}
          @selected=${(e: CustomEvent) => {
            this.dispatchSelectEvent(this, {
              matchField: this.matchField,
              selectedFieldValue: e.detail.selected.value,
            });
          }}
          @deselected=${() => {
            this.dispatchDeselectEvent(this, {
              matchField: this.matchField,
              selectedFieldValue: null,
            });
          }}
        ></match-field-select>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [MATCH_FIELD_ROW_ELEMENT_TAG]: MatchFieldRow;
  }
}
